(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire93c1"];
var parcelRegister = parcelRequire.register;
parcelRegister("dxivK", function(module, exports) {

$parcel$export(module.exports, "scroll", function () { return $9dacb75374e2364e$export$209876d7b1ac8f3; });

var $kTsUU = parcelRequire("kTsUU");

var $UGtav = parcelRequire("UGtav");

var $30GHi = parcelRequire("30GHi");

var $8WEVu = parcelRequire("8WEVu");
const $9dacb75374e2364e$var$scrollListeners = new WeakMap();
const $9dacb75374e2364e$var$resizeListeners = new WeakMap();
const $9dacb75374e2364e$var$onScrollHandlers = new WeakMap();
const $9dacb75374e2364e$var$getEventTarget = (element)=>element === document.documentElement ? window : element;
function $9dacb75374e2364e$export$209876d7b1ac8f3(onScroll, _a = {}) {
    var { container: container = document.documentElement } = _a, options = (0, $kTsUU.__rest)(_a, [
        "container"
    ]);
    let containerHandlers = $9dacb75374e2364e$var$onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        $9dacb75374e2364e$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, $30GHi.createScrollInfo)();
    const containerHandler = (0, $8WEVu.createOnScrollHandler)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!$9dacb75374e2364e$var$scrollListeners.has(container)) {
        const listener = ()=>{
            const time = performance.now();
            for (const handler of containerHandlers)handler.measure();
            for (const handler of containerHandlers)handler.update(time);
            for (const handler of containerHandlers)handler.notify();
        };
        $9dacb75374e2364e$var$scrollListeners.set(container, listener);
        const target = $9dacb75374e2364e$var$getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $9dacb75374e2364e$var$resizeListeners.set(container, (0, $UGtav.resize)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const listener = $9dacb75374e2364e$var$scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return ()=>{
        var _a;
        if (typeof onScroll !== "function") onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */ const containerHandlers = $9dacb75374e2364e$var$onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const listener = $9dacb75374e2364e$var$scrollListeners.get(container);
        $9dacb75374e2364e$var$scrollListeners.delete(container);
        if (listener) {
            $9dacb75374e2364e$var$getEventTarget(container).removeEventListener("scroll", listener);
            (_a = $9dacb75374e2364e$var$resizeListeners.get(container)) === null || _a === void 0 || _a();
            window.removeEventListener("resize", listener);
        }
    };
}

});
parcelRegister("kTsUU", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $f35f6002e28955fc$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f35f6002e28955fc$var$extendStatics = function(d, b) {
    $f35f6002e28955fc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f35f6002e28955fc$var$extendStatics(d, b);
};
function $f35f6002e28955fc$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f35f6002e28955fc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f35f6002e28955fc$export$18ce0697a983be9b = function() {
    $f35f6002e28955fc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f35f6002e28955fc$export$18ce0697a983be9b.apply(this, arguments);
};
function $f35f6002e28955fc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f35f6002e28955fc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f35f6002e28955fc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f35f6002e28955fc$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f35f6002e28955fc$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f35f6002e28955fc$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f35f6002e28955fc$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f35f6002e28955fc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f35f6002e28955fc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f35f6002e28955fc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f35f6002e28955fc$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f35f6002e28955fc$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f35f6002e28955fc$export$45d3717a4c69092e(o, m, p);
}
function $f35f6002e28955fc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f35f6002e28955fc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f35f6002e28955fc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f35f6002e28955fc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f35f6002e28955fc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f35f6002e28955fc$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f35f6002e28955fc$export$10c90e4f7922046c(v) {
    return this instanceof $f35f6002e28955fc$export$10c90e4f7922046c ? (this.v = v, this) : new $f35f6002e28955fc$export$10c90e4f7922046c(v);
}
function $f35f6002e28955fc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f35f6002e28955fc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f35f6002e28955fc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f35f6002e28955fc$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f35f6002e28955fc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f35f6002e28955fc$export$19a8beecd37a4c45 === "function" ? $f35f6002e28955fc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f35f6002e28955fc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f35f6002e28955fc$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f35f6002e28955fc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f35f6002e28955fc$export$45d3717a4c69092e(result, mod, k);
    }
    $f35f6002e28955fc$var$__setModuleDefault(result, mod);
    return result;
}
function $f35f6002e28955fc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f35f6002e28955fc$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f35f6002e28955fc$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f35f6002e28955fc$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f35f6002e28955fc$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f35f6002e28955fc$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f35f6002e28955fc$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f35f6002e28955fc$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f35f6002e28955fc$export$2e2bcd8739ae039 = {
    __extends: $f35f6002e28955fc$export$a8ba968b8961cb8a,
    __assign: $f35f6002e28955fc$export$18ce0697a983be9b,
    __rest: $f35f6002e28955fc$export$3c9a16f847548506,
    __decorate: $f35f6002e28955fc$export$29e00dfd3077644b,
    __param: $f35f6002e28955fc$export$d5ad3fd78186038f,
    __metadata: $f35f6002e28955fc$export$f1db080c865becb9,
    __awaiter: $f35f6002e28955fc$export$1050f835b63b671e,
    __generator: $f35f6002e28955fc$export$67ebef60e6f28a6,
    __createBinding: $f35f6002e28955fc$export$45d3717a4c69092e,
    __exportStar: $f35f6002e28955fc$export$f33643c0debef087,
    __values: $f35f6002e28955fc$export$19a8beecd37a4c45,
    __read: $f35f6002e28955fc$export$8d051b38c9118094,
    __spread: $f35f6002e28955fc$export$afc72e2116322959,
    __spreadArrays: $f35f6002e28955fc$export$6388937ca91ccae8,
    __spreadArray: $f35f6002e28955fc$export$1216008129fb82ed,
    __await: $f35f6002e28955fc$export$10c90e4f7922046c,
    __asyncGenerator: $f35f6002e28955fc$export$e427f37a30a4de9b,
    __asyncDelegator: $f35f6002e28955fc$export$bbd80228419bb833,
    __asyncValues: $f35f6002e28955fc$export$e3b29a3d6162315f,
    __makeTemplateObject: $f35f6002e28955fc$export$4fb47efe1390b86f,
    __importStar: $f35f6002e28955fc$export$c21735bcef00d192,
    __importDefault: $f35f6002e28955fc$export$da59b14a69baef04,
    __classPrivateFieldGet: $f35f6002e28955fc$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f35f6002e28955fc$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f35f6002e28955fc$export$81fdc39f203e4e04,
    __addDisposableResource: $f35f6002e28955fc$export$88ac25d8e944e405,
    __disposeResources: $f35f6002e28955fc$export$8f076105dc360e92
};

});

parcelRegister("UGtav", function(module, exports) {

$parcel$export(module.exports, "resize", function () { return $0aa62ca09c8d3860$export$4380c87abf28fdf; });

var $hFzRK = parcelRequire("hFzRK");

var $hTFvD = parcelRequire("hTFvD");

var $1BJop = parcelRequire("1BJop");
function $0aa62ca09c8d3860$export$4380c87abf28fdf(a, b) {
    return (0, $1BJop.isFunction)(a) ? (0, $hTFvD.resizeWindow)(a) : (0, $hFzRK.resizeElement)(a, b);
}

});
parcelRegister("hFzRK", function(module, exports) {

$parcel$export(module.exports, "resizeElement", function () { return $cdd2163df494ec01$export$81a0e12ec749d682; });

var $jcurC = parcelRequire("jcurC");
const $cdd2163df494ec01$var$resizeHandlers = new WeakMap();
let $cdd2163df494ec01$var$observer;
function $cdd2163df494ec01$var$getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize: inlineSize, blockSize: blockSize } = borderBoxSize[0];
        return {
            width: inlineSize,
            height: blockSize
        };
    } else if (target instanceof SVGElement && "getBBox" in target) return target.getBBox();
    else return {
        width: target.offsetWidth,
        height: target.offsetHeight
    };
}
function $cdd2163df494ec01$var$notifyTarget({ target: target, contentRect: contentRect, borderBoxSize: borderBoxSize }) {
    var _a;
    (_a = $cdd2163df494ec01$var$resizeHandlers.get(target)) === null || _a === void 0 || _a.forEach((handler)=>{
        handler({
            target: target,
            contentSize: contentRect,
            get size () {
                return $cdd2163df494ec01$var$getElementSize(target, borderBoxSize);
            }
        });
    });
}
function $cdd2163df494ec01$var$notifyAll(entries) {
    entries.forEach($cdd2163df494ec01$var$notifyTarget);
}
function $cdd2163df494ec01$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $cdd2163df494ec01$var$observer = new ResizeObserver($cdd2163df494ec01$var$notifyAll);
}
function $cdd2163df494ec01$export$81a0e12ec749d682(target, handler) {
    if (!$cdd2163df494ec01$var$observer) $cdd2163df494ec01$var$createResizeObserver();
    const elements = (0, $jcurC.resolveElements)(target);
    elements.forEach((element)=>{
        let elementHandlers = $cdd2163df494ec01$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $cdd2163df494ec01$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $cdd2163df494ec01$var$observer === null || $cdd2163df494ec01$var$observer === void 0 || $cdd2163df494ec01$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $cdd2163df494ec01$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 || elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $cdd2163df494ec01$var$observer === null || $cdd2163df494ec01$var$observer === void 0 || $cdd2163df494ec01$var$observer.unobserve(element);
        });
    };
}

});

parcelRegister("hTFvD", function(module, exports) {

$parcel$export(module.exports, "resizeWindow", function () { return $d077c59e4823e6c9$export$7fc81011b72cd94d; });
const $d077c59e4823e6c9$var$windowCallbacks = new Set();
let $d077c59e4823e6c9$var$windowResizeHandler;
function $d077c59e4823e6c9$var$createWindowResizeHandler() {
    $d077c59e4823e6c9$var$windowResizeHandler = ()=>{
        const size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const info = {
            target: window,
            size: size,
            contentSize: size
        };
        $d077c59e4823e6c9$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $d077c59e4823e6c9$var$windowResizeHandler);
}
function $d077c59e4823e6c9$export$7fc81011b72cd94d(callback) {
    $d077c59e4823e6c9$var$windowCallbacks.add(callback);
    if (!$d077c59e4823e6c9$var$windowResizeHandler) $d077c59e4823e6c9$var$createWindowResizeHandler();
    return ()=>{
        $d077c59e4823e6c9$var$windowCallbacks.delete(callback);
        if (!$d077c59e4823e6c9$var$windowCallbacks.size && $d077c59e4823e6c9$var$windowResizeHandler) $d077c59e4823e6c9$var$windowResizeHandler = undefined;
    };
}

});


parcelRegister("30GHi", function(module, exports) {

$parcel$export(module.exports, "createScrollInfo", function () { return $23127df58f22152c$export$38ba9ec5092d2d70; });
$parcel$export(module.exports, "updateScrollInfo", function () { return $23127df58f22152c$export$55f50a00c84f0ed3; });

var $jGnvE = parcelRequire("jGnvE");
var $3FIFR = parcelRequire("3FIFR");
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const $23127df58f22152c$var$maxElapsed = 50;
const $23127df58f22152c$var$createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const $23127df58f22152c$export$38ba9ec5092d2d70 = ()=>({
        time: 0,
        x: $23127df58f22152c$var$createAxisInfo(),
        y: $23127df58f22152c$var$createAxisInfo()
    });
const $23127df58f22152c$var$keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function $23127df58f22152c$var$updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length: length, position: position } = $23127df58f22152c$var$keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element["scroll" + position];
    axis.scrollLength = element["scroll" + length] - element["client" + length];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, $jGnvE.progress)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > $23127df58f22152c$var$maxElapsed ? 0 : (0, $3FIFR.velocityPerSecond)(axis.current - prev, elapsed);
}
function $23127df58f22152c$export$55f50a00c84f0ed3(element, info, time) {
    $23127df58f22152c$var$updateAxisInfo(element, "x", info, time);
    $23127df58f22152c$var$updateAxisInfo(element, "y", info, time);
    info.time = time;
}

});
parcelRegister("3FIFR", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $2ac7dac68da906ab$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $2ac7dac68da906ab$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("8WEVu", function(module, exports) {

$parcel$export(module.exports, "createOnScrollHandler", function () { return $68337c97db5f33f4$export$9dd72aeec3645b49; });

var $1BJop = parcelRequire("1BJop");
var $k6HuH = parcelRequire("k6HuH");

var $30GHi = parcelRequire("30GHi");

var $f82R1 = parcelRequire("f82R1");
function $68337c97db5f33f4$var$measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node != container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function $68337c97db5f33f4$export$9dd72aeec3645b49(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: ()=>$68337c97db5f33f4$var$measure(element, options.target, info),
        update: (time)=>{
            (0, $30GHi.updateScrollInfo)(element, info, time);
            if (options.offset || options.target) (0, $f82R1.resolveOffsets)(element, info, options);
        },
        notify: (0, $1BJop.isFunction)(onScroll) ? ()=>onScroll(info) : $68337c97db5f33f4$var$scrubAnimation(onScroll, info[axis])
    };
}
function $68337c97db5f33f4$var$scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing: easing })=>{
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing) animation.easing = (0, $k6HuH.noopReturn);
            animation.updateDuration(1);
        } else {
            const timingOptions = {
                duration: 1000
            };
            if (!easing) timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 || _b.call(_a, timingOptions);
        }
    });
    return ()=>{
        controls.currentTime = axisInfo.progress;
    };
}

});
parcelRegister("f82R1", function(module, exports) {

$parcel$export(module.exports, "resolveOffsets", function () { return $b039d12532890c3c$export$44b097f22602edfc; });

var $iv7oR = parcelRequire("iv7oR");
var $imupt = parcelRequire("imupt");

var $fXqwE = parcelRequire("fXqwE");

var $ghpQn = parcelRequire("ghpQn");

var $f7WHF = parcelRequire("f7WHF");
const $b039d12532890c3c$var$point = {
    x: 0,
    y: 0
};
function $b039d12532890c3c$export$44b097f22602edfc(container, info, options) {
    let { offset: offsetDefinition = (0, $ghpQn.ScrollOffset).All } = options;
    const { target: target = container, axis: axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, $fXqwE.calcInset)(target, container) : $b039d12532890c3c$var$point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : {
        width: target.clientWidth,
        height: target.clientHeight
    };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, $f7WHF.resolveOffset)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, $imupt.interpolate)((0, $iv7oR.defaultOffset)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}

});
parcelRegister("fXqwE", function(module, exports) {

$parcel$export(module.exports, "calcInset", function () { return $b9e0f123ef6712d5$export$6858938830d6a6db; });
function $b9e0f123ef6712d5$export$6858938830d6a6db(element, container) {
    let inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top: top, left: left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */ while(current && current.tagName !== "svg")current = current.parentNode;
        }
    }
    return inset;
}

});

parcelRegister("ghpQn", function(module, exports) {

$parcel$export(module.exports, "ScrollOffset", function () { return $bda247e2f378d374$export$e59548524dcf6540; });
const $bda247e2f378d374$export$e59548524dcf6540 = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};

});

parcelRegister("f7WHF", function(module, exports) {

$parcel$export(module.exports, "resolveOffset", function () { return $b0350bb6c7324871$export$1d98ea10734f1dc1; });

var $l6W4t = parcelRequire("l6W4t");
var $dxhBU = parcelRequire("dxhBU");

var $eU6aE = parcelRequire("eU6aE");
const $b0350bb6c7324871$var$defaultOffset = [
    0,
    0
];
function $b0350bb6c7324871$export$1d98ea10734f1dc1(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : $b0350bb6c7324871$var$defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0, $l6W4t.isNumber)(offset)) /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if ((0, $dxhBU.isString)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, $eU6aE.namedEdges)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, $eU6aE.resolveEdge)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, $eU6aE.resolveEdge)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}

});
parcelRegister("eU6aE", function(module, exports) {

$parcel$export(module.exports, "namedEdges", function () { return $ad9b150801ef7b8f$export$5329d185756d2568; });
$parcel$export(module.exports, "resolveEdge", function () { return $ad9b150801ef7b8f$export$1a4fccdf0f25754b; });

var $l6W4t = parcelRequire("l6W4t");
var $dxhBU = parcelRequire("dxhBU");
const $ad9b150801ef7b8f$export$5329d185756d2568 = {
    start: 0,
    center: 0.5,
    end: 1
};
function $ad9b150801ef7b8f$export$1a4fccdf0f25754b(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if ($ad9b150801ef7b8f$export$5329d185756d2568[edge] !== undefined) edge = $ad9b150801ef7b8f$export$5329d185756d2568[edge];
    /**
     * Handle unit values
     */ if ((0, $dxhBU.isString)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if ((0, $l6W4t.isNumber)(edge)) delta = length * edge;
    return inset + delta;
}

});





})();
//# sourceMappingURL=parallax.b265fd01.js.map
